import { render, staticRenderFns } from "./ShipsPiPsc.vue?vue&type=template&id=457d0b36&scoped=true&"
import script from "./ShipsPiPsc.vue?vue&type=script&lang=js&"
export * from "./ShipsPiPsc.vue?vue&type=script&lang=js&"
import style0 from "./ShipsPiPsc.vue?vue&type=style&index=0&id=457d0b36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d0b36",
  null
  
)

export default component.exports